import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { useStores } from '../../../../../stores/useStores';
import { DEFAULT_TIMER } from '../../../../../utils/time';
import { GeneralWidgetTimer } from '../../GeneralWidget';

interface MiniGameWidgetTimerProps {
  eventId: string;
  extended?: boolean;
  className?: string;
}

function MiniGameWidgetTimerComponent(props: MiniGameWidgetTimerProps) {
  const { eventId, extended } = props;
  const { userFreeSpinsStore } = useStores();
  const { t } = useTranslation();
  const timer = userFreeSpinsStore.getFreeSpinTimerFormatted(eventId, t);

  return <GeneralWidgetTimer extended={extended} timerValue={timer || DEFAULT_TIMER} />;
}

export const MiniGameWidgetTimer = observer(MiniGameWidgetTimerComponent);
